var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "blacklist" },
      _vm._l(_vm.blacklistedNumbers, function(blacklistedNumber) {
        return _c(
          "div",
          {
            key: blacklistedNumber.id,
            staticClass: "row row-list-item setting"
          },
          [
            _c("div", { staticClass: "col col-100" }, [
              _vm._v(
                _vm._s(
                  !blacklistedNumber.startsWith("0")
                    ? "+" + blacklistedNumber
                    : blacklistedNumber
                ) + " "
              ),
              _c(
                "span",
                {
                  staticClass: "icon",
                  on: {
                    click: function($event) {
                      return _vm.removeBlackListNumber(blacklistedNumber)
                    }
                  }
                },
                [_c("delete-icon")],
                1
              )
            ])
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.blacklistedNumbers.length <= _vm.maxBlacklistNumbers
      ? _c(
          "div",
          { staticClass: "new-number row finance row-list-item setting" },
          [
            _vm.$root.app.platform == "android"
              ? _c(
                  "div",
                  {
                    staticClass: "col col-100",
                    class: {
                      "validation-error": _vm.$v.newBlacklistNumber.$error
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newBlacklistNumber,
                          expression: "newBlacklistNumber"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.newBlacklistNumber },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.addBlacklistNumber.apply(null, arguments)
                        },
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newBlacklistNumber = $event.target.value
                          },
                          function($event) {
                            return _vm.$v.newBlacklistNumber.$touch()
                          }
                        ]
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$root.app.platform == "ios"
              ? _c(
                  "div",
                  {
                    staticClass: "col col-100",
                    class: {
                      "validation-error": _vm.$v.newBlacklistNumber.$error
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newBlacklistNumber,
                          expression: "newBlacklistNumber"
                        }
                      ],
                      attrs: { type: "text", placeholder: "Nieuw nummer..." },
                      domProps: { value: _vm.newBlacklistNumber },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.addBlacklistNumber.apply(null, arguments)
                        },
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.newBlacklistNumber = $event.target.value
                          },
                          function($event) {
                            return _vm.$v.newBlacklistNumber.$touch()
                          }
                        ]
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm.blacklistedNumbers.length <= _vm.maxBlacklistNumbers
      ? _c("div", [
          _c("div", { staticClass: "row blacklist row-button" }, [
            _c("div", { staticClass: "col col-100" }, [
              _c(
                "button",
                {
                  staticClass: "button dub-button dub-button-space",
                  on: { click: _vm.addBlacklistNumber }
                },
                [_vm._v("Voeg toe")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [
        _vm._v("Geblokkeerde Nummers")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5996ac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5996ac6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blacklist.vue
// module id = null
// module chunks = 